import React from 'react';
import Button from 'gatsby-core-theme/src/components/atoms/button/index';

export default (props) => <Button {...props} />;
